import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { OverlayView, OverlayViewF } from '@react-google-maps/api';
import { util } from 'node-forge';

import AdvancedMarker from '../../CampsiteMap/AdvancedMarker';
import InfoWindow from './InfoWindow';

import { MARKER_Z_INDEX } from '../../CampsiteMap/constants';
import createCrossingMarker from '../../../lib/helpers/createCrossingMarker';

export const createBase64 = svg => `data:image/svg+xml;charset=UTF-8;base64,${util.encode64(svg)}`;

function Markers({
  activePort, onClick, ports, showMarker,
}) {
  const handleClick = useCallback(id => onClick(id), [onClick]);

  return ports.map((port) => {
    const position = {
      lat: port.lat,
      lng: port.lon,
    };

    const markerIsActive = port.name === activePort.portName && showMarker;

    const getPixelPositionOffset = (width, height) => ({
      x: -(width / 2),
      y: -height - 16,
    });

    const icon = createCrossingMarker();

    return (
      <AdvancedMarker
        icon={icon}
        key={port.name}
        position={position}
        onClick={() => handleClick(port.name)}
        zIndex={MARKER_Z_INDEX.CAMPSITE_MARKER}
      >
        {markerIsActive &&
          <OverlayViewF
            getPixelPositionOffset={getPixelPositionOffset}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            position={{
              lat: port.lat,
              lng: port.lon,
            }}
          >
            <InfoWindow text={port.name} />
          </OverlayViewF>
        }
      </AdvancedMarker>
    );
  });
}

Markers.propTypes = {
  ports: PropTypes.arrayOf(PropTypes.shape({})),
  onClick: PropTypes.func,
};

Markers.defaultProps = {
  ports: [],
  onClick: () => null,
};

export default Markers;
